import React from 'react';
import AgrabintaMap from '../AgrabintaMap/AgrabintaMap';

const Map = () => {
    return (
        <section id="section-map">
            <AgrabintaMap/>
        </section>
    )
}

export default Map;
